

export const companySizes = [
  { value: 'small', label: 'SizeSmallLabel' },
  { value: 'medium', label: 'SizeMediumLabel' },
  { value: 'large', label: 'SizeLargeLabel' },
]
